import { Checkbox, DataSource, ExcludableTextbox, Layout, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTelemarketingCallHistoryReport extends Layout {
    checkboxPageBreak: Checkbox;
    excludabletextboxUsers: ExcludableTextbox;
    sourceTelemarketingCallHist: DataSource;
    switchReportType: Switch;
    switchSort: Switch;
    switchSource: Switch;
    textboxCallDates: Textbox;
}
